<template>
    <PopupRouterView :showLeftIcon="true" label="Production Quality Inspection Dimension Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="productionqualityinspectiondimension"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="productionQualityInspectionDimensionInput">


        <b-card header="Production Quality Inspection Dimension" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Production Quality Inspection Number" :model="model.productionQualityInspectionNumber" />
						<app-input-combobox-autocomplete :options="workOrderProcesss" optionsLabel="workOrderProcessNumber" optionsKey="id" label-cols-lg="12" label="Work Order Process" id="fieldset-work-order-process" size="sm" :model.sync="model.workOrderProcessId"   :selected="model.workOrderProcess != null ? model.workOrderProcess.workOrderProcessNumber : ''" @input="getWorkOrderProcesss" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcess" />
						<app-input-datetimepicker id="fieldset-production-date" label-cols-lg="12"  label="Production Date" size="sm" :model.sync="model.productionDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Production Quality Inspection Dimension Detail"
			:bordered="true" :items="productionQualityInspectionDimensionDetails" 
			:fields="fieldsProductionQualityInspectionDimensionDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByProductionQualityInspectionDimensionDetail" 
			:sort-desc.sync="sortDescProductionQualityInspectionDimensionDetail" small responsive	
			@editButtonMethod="editRowDataProductionQualityInspectionDimensionDetail"	
			@deleteButtonMethod="deleteRowDataProductionQualityInspectionDimensionDetail"	
			@showPopupAddMethod="addDataProductionQualityInspectionDimensionDetail()"	
			@showPopupUploadMethod="showPopupUploadProductionQualityInspectionDimensionDetail()"
			@downloadMethod="downloadProductionQualityInspectionDimensionDetail()"
			@addFromClipboardMethod="addFromClipboardProductionQualityInspectionDimensionDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardProductionQualityInspectionDimensionDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadProductionQualityInspectionDimensionDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowProductionQualityInspectionDimensionDetailFilter = !isShowProductionQualityInspectionDimensionDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowProductionQualityInspectionDimensionDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select id="input-production-quality-inspection-dimension-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterProductionQualityInspectionDimensionDetail.partId" :reduce="item => item.id" v-model="filterProductionQualityInspectionDimensionDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Is Checked">
					<b-form-checkbox id="input-production-quality-inspection-dimension-detail-is-checked-table" class="float-right" v-model="filterProductionQualityInspectionDimensionDetail.isChecked"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Attachment">
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-production-quality-inspection-dimension-detail-remark-table" v-model="filterProductionQualityInspectionDimensionDetail.remark" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( productionQualityInspectionDimensionDetailPageSize * (currentProductionQualityInspectionDimensionDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-production-quality-inspection-dimension-detail-part-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputProductionQualityInspectionDimensionDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(customer)="row">
						<app-label label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null"  />
			</template>
			<template v-slot:cell(isChecked)="row">
				<app-input-checkbox :id="'input-production-quality-inspection-dimension-detail-is-checked-row-' + row.index" label-cols-lg="12" label="Is Checked" :model.sync="row.item.isChecked" @change="saveInputProductionQualityInspectionDimensionDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(attachment)="row">
				<app-input-fileupload :id="'input-production-quality-inspection-dimension-detail-attachment-' + row.index" label-cols-lg="12" label="Attachment" size="sm" :model.sync="attachments[row.item.id]" :currentModel="row.item.attachment" @change="saveInputProductionQualityInspectionDimensionDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :id="'input-production-quality-inspection-dimension-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputProductionQualityInspectionDimensionDetail(row.item)"   :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<ProductionQualityInspectionDimensionDetailInput 
					:model="modelProductionQualityInspectionDimensionDetail"
					:openPopup="isShowPopupProductionQualityInspectionDimensionDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataProductionQualityInspectionDimensionDetail"/>
			</template>
			<template v-slot:upload-detail>
					<ProductionQualityInspectionDimensionDetailUpload
					:openPopup="isShowPopupUploadProductionQualityInspectionDimensionDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataProductionQualityInspectionDimensionDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentProductionQualityInspectionDimensionDetailPage"
				:total-rows="totalProductionQualityInspectionDimensionDetailRow"
				:per-page="productionQualityInspectionDimensionDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProductionQualityInspectionDimension from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimension';
import ProductionQualityInspectionDimensionList from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionList';
import ProductionQualityInspectionDimensionFilter from '@/filters/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import ProductionQualityInspectionDimensionDetail from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetail';
import ProductionQualityInspectionDimensionDetailFilter from '@/filters/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppInputFileupload from '@/components/AppInputFileupload';
import Attachment from '@/models/Core/Attachment';
import AttachmentFilter from '@/filters/Core/AttachmentFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ProductionQualityInspectionDimensionDetailInput from '@/views/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetailInput';
import ProductionQualityInspectionDimensionDetailUpload from '@/views/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputCheckbox,
		AppInputFileupload,
		AppInputTextarea,
		ProductionQualityInspectionDimensionDetailInput,ProductionQualityInspectionDimensionDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsProductionQualityInspectionDimensionDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part Number", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"customer": { "class" : "th-customer last-child", "label" : "Customer", key: 'customer', sortable: false}}, 
				{"isChecked": { "class" : "th-is-checked d-stack-none", "label" : "Is Checked", key: 'isChecked', sortable: false}}, 
				{"attachment": { "class" : "th-attachment d-stack-none", "label" : "Attachment", key: 'attachment', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelProductionQualityInspectionDimensionDetail : {},
			isShowPopupProductionQualityInspectionDimensionDetail : false,
			isShowPopupUploadProductionQualityInspectionDimensionDetail : false,
			filterProductionQualityInspectionDimension : null,
			currentProductionQualityInspectionDimensionPage : 1,
			productionQualityInspectionDimensionPageSize: 10,
			sortByProductionQualityInspectionDimension: '',
			sortDescProductionQualityInspectionDimension: '',
			filterProductionQualityInspectionDimensionDetail : null,
			currentProductionQualityInspectionDimensionDetailPage : 1,
			productionQualityInspectionDimensionDetailPageSize: 10,
			sortByProductionQualityInspectionDimensionDetail: '',
			sortDescProductionQualityInspectionDimensionDetail: '',
			sortingByProductionQualityInspectionDimensionDetail: [],
			productionQualityInspectionDimensionDetails : [],
			productionQualityInspectionDimensionDetailId : '',
			totalProductionQualityInspectionDimensionDetailRow : 0,
			isShowProductionQualityInspectionDimensionDetailFilter: false,
			isDownloadProductionQualityInspectionDimensionDetail: false,
			parts: [],
			attachments: [],
			workOrderProcesss: [],
			workOrderProcesss: [],
			isWorkOrderProcessComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderProcessComboLoading: false,
			isProductionQualityInspectionDimensionComboLoading: false,
			isPartComboLoading: false,
			isAttachmentComboLoading: false,
		}
	},
	methods : {
		getProductionQualityInspectionDimension : async function(id) {
			this.isBusy = true;
			ProductionQualityInspectionDimension.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadProductionQualityInspectionDimension = true;
			this.filterProductionQualityInspectionDimension.id = this.modelId;
			ProductionQualityInspectionDimension.downloadDataDetail(this, this.filterProductionQualityInspectionDimension).then(result => {
				this.isDownloadProductionQualityInspectionDimension = false;
			}).catch(error => { this.isDownloadProductionQualityInspectionDimension = false; })
		},
		getProductionQualityInspectionDimensionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterProductionQualityInspectionDimensionDetail);
			if (this.modelId == null) return;
			filter.productionQualityInspectionDimensionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByProductionQualityInspectionDimensionDetail != null) {
				this.sortingByProductionQualityInspectionDimensionDetail[this.sortByProductionQualityInspectionDimensionDetail] = this.sortDescProductionQualityInspectionDimensionDetail;
			}
			let currentPage = (this.currentProductionQualityInspectionDimensionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalProductionQualityInspectionDimensionDetailRow + 1;
				let page = Math.ceil(totalData/this.productionQualityInspectionDimensionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.productionQualityInspectionDimensionDetailPageSize = 0;
			// disable paging end
			ProductionQualityInspectionDimensionDetail.getList(this, filter, this.sortingByProductionQualityInspectionDimensionDetail, currentPage , this.productionQualityInspectionDimensionDetailPageSize).then(result => {
				this.currentProductionQualityInspectionDimensionDetailPage = currentPage + 1;
				this.productionQualityInspectionDimensionDetails = result.data;
				this.totalProductionQualityInspectionDimensionDetailRow = result.dataCount;
				this.attachments = Array();
				for(var item of result.data) {
					this.attachments[item.id] = null;
				}

			}).catch(error => {});
		},
		getProductionQualityInspectionDimensions : async function(input) {
			let filter = new ProductionQualityInspectionDimensionFilter();
			if (input != undefined) {
				filter.WorkOrderProcess = input;
			}
			this.isProductionQualityInspectionDimensionComboLoading = true;
			ProductionQualityInspectionDimension.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionQualityInspectionDimensions = result.data
				}
				this.isProductionQualityInspectionDimensionComboLoading = false;
			})
			.catch(error => {});
		},
		getProductionQualityInspectionDimensions : async function(input) {
			let filter = new ProductionQualityInspectionDimensionFilter();
			if (input != undefined) {
				filter.workOrderProcess = input;
			}
			this.isProductionQualityInspectionDimensionComboLoading = true;
			ProductionQualityInspectionDimension.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionQualityInspectionDimensions = result.data
				}
				this.isProductionQualityInspectionDimensionComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getAttachments : async function(input) {
			let filter = new AttachmentFilter();
			if (input != undefined) {
				filter.originalFilename = input;
			}
			this.isAttachmentComboLoading = true;
			Attachment.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.attachments = result.data
				}
				this.isAttachmentComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcess(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessId = null;
				this.model.workOrderProcess = null;
			} else {
				this.model.workOrderProcessId = item.id;
				this.model.workOrderProcess = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.productionQualityInspectionDimensionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionDimension.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'productionqualityinspectiondimensionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					ProductionQualityInspectionDimension.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'productionqualityinspectiondimensionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionDimension.updateData(this, model, id)
					.catch((error) => {
						this.getProductionQualityInspectionDimension(id);
					});
				}
			});
		},
		onHidden() {
			this.getProductionQualityInspectionDimensions();
		},
		addRowDataProductionQualityInspectionDimensionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.productionQualityInspectionDimensionId =  this.modelId;
					ProductionQualityInspectionDimensionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getProductionQualityInspectionDimensionDetails(true);
						this.isShowPopupProductionQualityInspectionDimensionDetail = false;
					})
				} else {
					model.productionQualityInspectionDimensionId =  this.modelId;
					ProductionQualityInspectionDimensionDetail.createDataDetail(this, model)
					.then(result => {
						this.getProductionQualityInspectionDimensionDetails(true);
						this.isShowPopupProductionQualityInspectionDimensionDetail = false;
					})
				}
			}
		},
		async editRowDataProductionQualityInspectionDimensionDetail(id) {
			this.productionQualityInspectionDimensionDetailId = id;
			this.isShowPopupProductionQualityInspectionDimensionDetail = true; 
		},
		async deleteRowDataProductionQualityInspectionDimensionDetail(id) {
			ProductionQualityInspectionDimensionDetail.deleteData(this, id).then(result => { this.getProductionQualityInspectionDimensionDetails(); });
		},
		async resetDataProductionQualityInspectionDimensionDetail() {
			this.productionQualityInspectionDimensionDetailId = "";
			this.isShowPopupProductionQualityInspectionDimensionDetail = true;
		},
		async addDataProductionQualityInspectionDimensionDetail() {
			ProductionQualityInspectionDimensionDetail.createData(this, { productionQualityInspectionDimensionId: this.modelId })
			.then(result => {
				this.getProductionQualityInspectionDimensionDetails(true);
			})
		},
		async addFromClipboardProductionQualityInspectionDimensionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, productionQualityInspectionDimensionId: this.modelId });
				});
				ProductionQualityInspectionDimensionDetail.addFromClipboard(this, parts).then(result => { this.getProductionQualityInspectionDimensionDetails() });
			});
		},
		async replaceFromClipboardProductionQualityInspectionDimensionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, productionQualityInspectionDimensionId: this.modelId });
				});
				ProductionQualityInspectionDimensionDetail.replaceFromClipboard(this, parts).then(result => { this.getProductionQualityInspectionDimensionDetails() });
			});   
		},
		showPopupUploadProductionQualityInspectionDimensionDetail() {
			if(this.productionQualityInspectionDimensionDetails != null && this.productionQualityInspectionDimensionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap ProductionQualityInspectionDimensionDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadProductionQualityInspectionDimensionDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadProductionQualityInspectionDimensionDetail = true;
			}
		},
		uploadDataProductionQualityInspectionDimensionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadProductionQualityInspectionDimensionDetail = false; 
		},
		downloadProductionQualityInspectionDimensionDetail(modalEvent) {
			this.isDownloadProductionQualityInspectionDimensionDetail = true;
			this.filterProductionQualityInspectionDimensionDetail.productionQualityInspectionDimensionId = this.modelId;
			ProductionQualityInspectionDimensionDetail.downloadDataDetail(this, this.filterProductionQualityInspectionDimensionDetail).then(result => {
				this.isDownloadProductionQualityInspectionDimensionDetail = false;
			}).catch(error => { this.isDownloadProductionQualityInspectionDimensionDetail = false; })
		},
		saveInputProductionQualityInspectionDimensionDetail(item) {
			if (this.productionQualityInspectionDimensions != null && this.productionQualityInspectionDimensions != undefined  && this.productionQualityInspectionDimensions.length > 0) {
				item.productionQualityInspectionDimension = this.productionQualityInspectionDimensions.find(q => q.id == item.productionQualityInspectionDimensionId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();
			if (this.attachments[id] != null) {
				let data = new FormData();
				data.append('file', this.attachments[id]);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								item.attachmentId = response.data.id;
								item.attachment = response.data;
								_this.attachments[id] = null;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionDimensionDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadProductionQualityInspectionDimensionDetail = false; 
			this.isShowPopupProductionQualityInspectionDimensionDetail = false; 
			if (modalType == 'ProductionQualityInspectionDimensionDetail') {
				this.getProductionQualityInspectionDimensionDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowProductionQualityInspectionDimensionDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterProductionQualityInspectionDimension = new ProductionQualityInspectionDimensionFilter();
		this.filterProductionQualityInspectionDimensionDetail = new ProductionQualityInspectionDimensionDetailFilter();
		//this.getProductionQualityInspectionDimensions();
		//this.getParts();
		//this.getWorkOrderProcesss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getProductionQualityInspectionDimension(id);
			} else {
				this.modelId = id;
				this.getProductionQualityInspectionDimension(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByProductionQualityInspectionDimensionDetail : {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		sortDescProductionQualityInspectionDimensionDetail: {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		currentProductionQualityInspectionDimensionDetailPage: {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		productionQualityInspectionDimensionDetailPageSize : {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			}
		},
		filterProductionQualityInspectionDimensionDetail: {
			handler: function() {
				this.getProductionQualityInspectionDimensionDetails();
			},
			deep: true,
		},
	},
}
</script>
